import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton, scrollToPricing } from './CTAButton';
import { productImage } from '../data/content';
export function Hero() {
  return <header className="bg-brand-navy px-4 py-5 text-center text-white sm:px-6 sm:py-6" data-id="element-80" data-mp="9kjuahxxms0i">
      <h1 className="mx-auto mb-2 max-w-2xl text-[22px] font-extrabold uppercase leading-[1.1] sm:text-4xl" data-id="element-81" data-mp="4lqf8l2zysy8">
        The Complete Coaching System For{' '}
        <span className="text-brand-green" data-id="element-82" data-mp="128yz6bncnty4">Pickleball Coaches &amp; Instructors</span>
      </h1>
      <p className="mx-auto mb-1 max-w-xl text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-83" data-mp="xaxghrtu5wn6">
        Stop wasting hours planning sessions, searching for drills, and figuring out what to teach
        next.
      </p>
      <p className="mx-auto mb-3 max-w-xl text-[13px] font-bold leading-snug sm:text-base" data-id="element-84" data-mp="nekm0rqgverd">
        Everything you need is finally organized into one complete professional coaching system.
      </p>
      <button type="button" onClick={scrollToPricing} className="mb-3 block w-full focus:outline-none focus:ring-2 focus:ring-brand-green" aria-label="Go to the offer section" data-id="element-85" data-mp="384s4wnk2qj2j">
        <img src={productImage} alt="Pickleball Coach Pro complete 6-in-1 coaching and training system box set" className="mx-auto w-full max-w-[300px] object-contain drop-shadow-[0_16px_36px_rgba(0,0,0,0.45)] transition-transform duration-200 hover:scale-[1.02] sm:max-w-[360px]" data-id="element-86" data-mp="39alaige2es47" />
      </button>
      <div className="mx-auto mb-2 max-w-md" data-id="element-87" data-mp="359sy5e9wc73p">
        <CTAButton data-id="element-88" data-mp="35aknw8gtbam2">🚀 YES! I WANT MY SYSTEM NOW</CTAButton>
      </div>
      <div className="flex flex-col items-center justify-center gap-0.5 text-[11px] font-bold sm:flex-row sm:gap-4 sm:text-xs" data-id="element-89" data-mp="2qlepuntpnqfr">
        <span data-id="element-90" data-mp="2vglkl6505ksj">⭐⭐⭐⭐⭐ 4.9/5 — Verified Coach Reviews</span>
        <span className="flex items-center gap-1" data-id="element-91" data-mp="2hkggdq0i6qps">
          <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-green" aria-hidden="true" data-id="element-92" data-mp="2lkqwhvi0exid" />
          7-Day Money-Back Guarantee — Zero Risk
        </span>
      </div>
    </header>;
}